import { pluralizeWithCount } from "@common/helpers/string";
import { Pagination } from "@design-system/Pagination/Pagination";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";

interface PaginatedTableFooterProps {
    total: number;
    pageCount: number;
    page: number;
    onPageChange: (page: number) => void;
    itemLabel: string;
}

export const PaginatedTableFooter = ({
    total,
    pageCount,
    page,
    onPageChange,
    itemLabel,
}: PaginatedTableFooterProps) => (
    <CommandIsland
        sticky
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <HStack gap={8}>
            {pageCount > 1 ? (
                <Pagination
                    size="md"
                    pageCount={pageCount}
                    currentPage={page}
                    onPageChange={onPageChange}
                />
            ) : (
                <CommandIslandTotal>
                    {pluralizeWithCount(itemLabel, total)}
                </CommandIslandTotal>
            )}
        </HStack>
    </CommandIsland>
);
